import { render, staticRenderFns } from "./CourseFormDialog.vue?vue&type=template&id=ec506a24&scoped=true"
import script from "./CourseFormDialog.vue?vue&type=script&lang=js"
export * from "./CourseFormDialog.vue?vue&type=script&lang=js"
import style0 from "./CourseFormDialog.vue?vue&type=style&index=0&id=ec506a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec506a24",
  null
  
)

export default component.exports